import { ChatStore } from "@/stores/ChatStore";
import type { Message } from "@/types";
import { v4 } from "uuid";

export default function onReceivedInputAudioBufferSpeechStarted(message: Message) {
  console.log("Speech started ", message);

  // create an empty message to indicate that the user is speaking
  // value is set in onReceivedInputAudioTranscriptionCompleted()
  ChatStore.getState().addMessage({
    id: v4(),
    transcript: "",
    sender: "user",
    timestamp: new Date(),
  });

  ChatStore.getState().setAvatarStatus("Anhören")

  // if (!SettingsStore.getState().useAvatar) {
  //   stopAudioPlayer();
  // }

  ChatStore.getState().setIsForcedToInterrupt(true);
}
